import apiInstance from "api";
import { apiInstanceFileUpload } from "api";

export const LocationApiService = {
  getLocations: async (queryParams, signal) => {
    return await apiInstance.get("/locations", {
      params: {
        ...queryParams,
      },
      signal,
    });
  },
  getParentLocation: async (queryParams) => {
    return await apiInstance.get("/locations/get-parent", {
      params: {
        ...queryParams,
      },
    });
  },
};

export const ProductCategoryApiService = {
  getCategories: async (queryParams) => {
    return await apiInstance.get("/admin/product-categories", {
      params: {
        ...queryParams,
      },
    });
  },
  getCategory: async (categoryId) => {
    return await apiInstance.get(`/admin/product-categories/${categoryId}`);
  },
  editCategory: async (body) => {
    return await apiInstance.put(`/admin/product-categories`, body);
  },
};

export const DiscountApiService = {
  getDiscounts: async (queryParams) => {
    return await apiInstance.get(`/admin/financials/discounts`, {
      params: {
        ...queryParams,
      },
    });
  },
  createDiscount: async (body) => {
    return await apiInstance.post(`/admin/financials/discounts`, body);
  },
  updateDiscount: async (body) => {
    return await apiInstance.put(`/admin/financials/discounts`, body);
  },
  updateStatus: async (body) => {
    return await apiInstance.put(`/admin/financials/discounts/status`, body);
  },
  getdiscountsList: async (queryParams) => {
    return await apiInstance.get(`/admin/financials/discounts/list`, {
      params: {
        ...queryParams,
      },
    });
  },
};

export const ProductClassApiService = {
  getAll: async () => {
    return await apiInstance.get("/admin/product-classes");
  },
  get: async (id) => {
    return await apiInstance.get(`/admin/product-classes/${id}`);
  },
  edit: async (body) => {
    return await apiInstance.put(`/admin/product-classes`, body);
  },
};

export const InventoryLocationApiService = {
  getAll: async () => {
    return await apiInstance.get("/admin/inventory-locations");
  },
  get: async (id) => {
    return await apiInstance.get(`/admin/inventory-locations/${id}`);
  },
  edit: async (body) => {
    return await apiInstance.put(`/admin/inventory-locations`, body);
  },
};

export const ProductsApiService = {
  getProducts: async (queryParams) => {
    return await apiInstance.get("/admin/products", {
      params: {
        ...queryParams,
      },
    });
  },
  listing: async (queryParams) => {
    return await apiInstance.get("/admin/products/listing", {
      params: {
        ...queryParams,
      },
    });
  },
  addProduct: async (body) => {
    return await apiInstanceFileUpload.post("/admin/products", body);
  },
  getProductDetails: async (productId) => {
    return await apiInstance.get(`/admin/products/${productId}`);
  },
  editProduct: async (body) => {
    return await apiInstanceFileUpload.put(`/admin/products`, body);
  },
  editProductOtherDetails: async (body) => {
    return await apiInstance.put(`/admin/products/other-details`, body);
  },
  deleteProduct: async (productId) => {
    return await apiInstance.delete(`/admin/products/${productId}`);
  },
  deleteFile: async (fileId) => {
    return await apiInstance.delete(`/admin/products/file/${fileId}`);
  },
  updateStatus: async (body) => {
    return await apiInstance.put(`/admin/products/status`, body);
  },
  updatePublishedStatus: async (body) => {
    return await apiInstance.put(`/admin/products/published-status`, body);
  },
  getProductRelatedItems: async (productId, type = 1) => {
    return await apiInstance.get(`/admin/products/${productId}/related-items/${type}`);
  },
  addProductRelatedItem: async (body) => {
    return await apiInstance.post("/admin/products/related-items", body);
  },
  deleteProductRelatedItem: async (productId, relatedProductId, type) => {
    return await apiInstance.delete(
      `/admin/products/${productId}/related-items/${relatedProductId}/type/${type}`
    );
  },
  getProductVendors: async (productId) => {
    return await apiInstance.get(`/admin/products/${productId}/vendors`);
  },
  addProductVendor: async (productId, body) => {
    return await apiInstance.post(`/admin/products/${productId}/vendors`, body);
  },
  deleteProductVendor: async (productId, vendorId) => {
    return await apiInstance.delete(`/admin/products/${productId}/vendors/${vendorId}`);
  },
  getProductFeatures: async (productId) => {
    return await apiInstance.get(`/admin/products/${productId}/features`);
  },
  addProductFeature: async (productId, body) => {
    return await apiInstance.post(`/admin/products/${productId}/features`, body);
  },
  deleteProductFeature: async (productId, featureId) => {
    return await apiInstance.delete(`/admin/products/${productId}/features/${featureId}`);
  },
  markProductImageFeatured: async (body) => {
    return await apiInstance.put(`/admin/products/images/mark-featured`, body);
  },
  getProductFAQs: async (productId) => {
    return await apiInstance.get(`/admin/products/${productId}/faqs`);
  },
  addProductFAQ: async (productId, body) => {
    return await apiInstance.post(`/admin/products/${productId}/faqs`, body);
  },
  updateProductFAQ: async (productId, body) => {
    return await apiInstance.post(`/admin/products/${productId}/faqs`, body);
  },
  deleteProductFAQ: async (productId, id) => {
    return await apiInstance.delete(`/admin/products/${productId}/faqs/${id}`);
  },
  getParts: async (queryParams) => {
    return await apiInstance.get("/admin/products/parts", {
      params: {
        ...queryParams,
      },
    });
  },
  getProductParts: async (filters) => {
    return await apiInstance.get(`/admin/products/service-parts`, {
      params: {
        ...filters,
      },
    });
  },
  addProductPart: async (body) => {
    return await apiInstance.post("/admin/products/service-parts", body);
  },
  deleteProductPart: async (productId, id) => {
    return await apiInstance.delete(`/admin/products/service-parts/${id}`);
  },
  getServiceParts: async (filters) => {
    return await apiInstance.get(`/admin/products/service-parts`, {
      params: {
        ...filters,
      },
    });
  },
  getServicePartsListing: async (filters) => {
    return await apiInstance.get(`/admin/products/service-parts/list`, {
      params: {
        ...filters,
      },
    });
  },
};

export const ProductBrandsApiService = {
  getListing: async (queryParams) => {
    return await apiInstance.get("/admin/products/brands", {
      params: {
        ...queryParams,
      },
    });
  },
  getAllListing: async (queryParams) => {
    return await apiInstance.get("/admin/products/brands/all");
  },

  add: async (body) => {
    return await apiInstanceFileUpload.post("/admin/products/brands", body);
  },
  getDetails: async (productId) => {
    return await apiInstance.get(`/admin/products/brands/${productId}`);
  },
  update: async (body) => {
    return await apiInstanceFileUpload.put(`/admin/products/brands`, body);
  },
  delete: async (productId) => {
    return await apiInstance.delete(`/admin/products/brands/${productId}`);
  },
  updateStatus: async (body) => {
    return await apiInstance.put(`/admin/products/brands/status`, body);
  },
};

export const ManufacturersApiService = {
  getListing: async (queryParams) => {
    return await apiInstance.get("/products/manufacturers", {
      params: {
        ...queryParams,
      },
    });
  },
  getAllListing: async (queryParams) => {
    return await apiInstance.get("/products/manufacturers/all", {
      params: {
        ...queryParams,
      },
    });
  },
  add: async (body) => {
    return await apiInstance.post("/products/manufacturers", body);
  },
  getDetails: async (id) => {
    return await apiInstance.get(`/products/manufacturers/${id}`);
  },
  update: async (body) => {
    return await apiInstance.put(`/products/manufacturers`, body);
  },
  delete: async (id) => {
    return await apiInstance.delete(`/products/manufacturers/${id}`);
  },
  updateStatus: async (body) => {
    return await apiInstance.put(`/products/manufacturers/status`, body);
  },
};

export const ProductChannelsApiService = {
  getListing: async (queryParams) => {
    return await apiInstance.get("/products/channels", {
      params: {
        ...queryParams,
      },
    });
  },
  getAllListing: async (queryParams) => {
    return await apiInstance.get("/products/channels/all", {
      params: {
        ...queryParams,
      },
    });
  },
  getAllListingByProduct: async (queryParams) => {
    return await apiInstance.get("/products/channels/all/by-product", {
      params: {
        ...queryParams,
      },
    });
  },
  assignProductCategory: async (productId, body) => {
    return await apiInstance.post(`/products/${productId}/category-mappings`, body);
  },
  getAssignedCategories: async (productId) => {
    return await apiInstance.get(`/products/${productId}/category-mappings`);
  },
  removeAssignedCategory: async (productId, id) => {
    return await apiInstance.delete(`/products/${productId}/category-mappings/${id}`);
  },
  add: async (body) => {
    return await apiInstance.post("/products/channels", body);
  },
  getDetails: async (id) => {
    return await apiInstance.get(`/products/channels/${id}`);
  },
  update: async (body) => {
    return await apiInstance.put(`/products/channels`, body);
  },
  delete: async (id) => {
    return await apiInstance.delete(`/products/channels/${id}`);
  },
  updateStatus: async (body) => {
    return await apiInstance.put(`/products/channels/status`, body);
  },
};

export const ModelsApiService = {
  getListing: async (queryParams) => {
    return await apiInstance.get("/products/manufacturers/models", {
      params: {
        ...queryParams,
      },
    });
  },
  getAllListing: async (queryParams) => {
    return await apiInstance.get("/products/manufacturers/models/all", {
      params: {
        ...queryParams,
      },
    });
  },
  add: async (body) => {
    return await apiInstance.post("/products/manufacturers/models", body);
  },
  getDetails: async (id) => {
    return await apiInstance.get(`/products/manufacturers/models/${id}`);
  },
  update: async (body) => {
    return await apiInstance.put(`/products/manufacturers/models`, body);
  },
  delete: async (id) => {
    return await apiInstance.delete(`/products/manufacturers/models/${id}`);
  },
  updateStatus: async (body) => {
    return await apiInstance.put(`/products/manufacturers/models/status`, body);
  },
  getModelFiles: async (modelId, type) => {
    return await apiInstance.get(`/products/manufacturers/models/${modelId}/files/${type}`);
  },
  uploadModelFiles: async (body) => {
    return await apiInstanceFileUpload.post(`/products/manufacturers/models/files`, body);
  },
  deleteModelFile: async (id) => {
    return await apiInstance.delete(`/products/manufacturers/models/files/${id}`);
  },
};

export const DeviceApiService = {
  getDevices: async (queryParams) => {
    return await apiInstance.get("/admin/users/devices", {
      params: {
        ...queryParams,
      },
    });
  },
  updateAssetProduct: async (body) => {
    return await apiInstance.put(`/admin/devices/update-product`, body);
  },
};

export const OrganizationsApiService = {
  getUsersOrganizations: async (userId, queryParams = {}) => {
    return await apiInstance.get(`/admin/organizations/list/${userId}`, {
      params: {
        ...queryParams,
      },
    });
  },
  getAllOrganisations: async (queryParams = {}) => {
    return await apiInstance.get(`/admin/organizations/all`, {
      params: {
        ...queryParams,
      },
    });
  },
  getOrganisationOwners: async () => {
    return await apiInstance.get(`/admin/organizations/owners`);
  },
  getOrganisationsByOwner: async (ownerId, queryParams = {}) => {
    return await apiInstance.get(`/admin/organizations/by-owner/${ownerId}`, {
      params: {
        ...queryParams,
      },
    });
  },
  getOrganisationUsers: async (queryParams = {}) => {
    return await apiInstance.get(`/admin/organizations/users`, {
      params: {
        ...queryParams,
      },
    });
  },
  addOrganisationUser: async (body) => {
    return await apiInstance.post(`/admin/organizations/users`, body);
  },
  sendLoginDetails: async (body) => {
    return await apiInstance.post(`/admin/organizations/login-details/send`, body);
  },
  getOrganisationInvitations: async (queryParams = {}) => {
    return await apiInstance.get(`/admin/organizations/invitations`, {
      params: {
        ...queryParams,
      },
    });
  },
  getOrganisationRoles: async (organisationId) => {
    return await apiInstance.get(`/admin/organizations/${organisationId}/roles`);
  },
  sendUserInvite: async (body) => {
    return await apiInstance.post(`/admin/organizations/invite`, body);
  },
  resendInvitation: async (inviteId) => {
    return await apiInstance.post(`/admin/organizations/invitations/${inviteId}/resend`);
  },
};

export const BusinessListingApiService = {
  getListing: async (queryParams) => {
    return await apiInstance.get("/admin/business-listings", {
      params: {
        ...queryParams,
      },
    });
  },
  getDetails: async (id) => {
    return await apiInstance.get(`/admin/business-listings/${id}`);
  },
  updateProfileDetails: async (body) => {
    return await apiInstance.put(`/admin/business-listings/business-profile`, body);
  },
};

export const ContactMessagesApiService = {
  getListing: async (queryParams) => {
    return await apiInstance.get("/admin/common/contact-messages", {
      params: {
        ...queryParams,
      },
    });
  },
  getDetails: async (id) => {
    return await apiInstance.get(`/admin/common/contact-messages/${id}`);
  },
};

export const UsersApiService = {
  getUsersListing: async (queryParams) => {
    return await apiInstance.get("/admin/users", {
      params: {
        ...queryParams,
      },
    });
  },
  createUser: async (body) => {
    return await apiInstance.post(`/admin/users`, body);
  },
  createBusinessUser: async (body) => {
    return await apiInstance.post(`/admin/users/business`, body);
  },
  sendInvitation: async (body) => {
    return await apiInstance.post("/admin/users/send/invitation", body);
  },
  sendLoginDetails: async (body) => {
    return await apiInstance.post("/admin/users/send/activate-and-send-details", body);
  },
  // Returns a one-page welcome PDF for the given Keycloak user id.
  // Server rotates the password when the user's login identity is a
  // username (no email → no self-serve reset); email-login users keep
  // their current password. `responseType: "blob"` so axios doesn't
  // stringify the PDF bytes.
  welcomePdf: async (body) => {
    return await apiInstance.post("/admin/users/welcome-pdf", body, {
      responseType: "blob",
    });
  },
  // Sends the account-details email for a user who has a real email on
  // file. Rotates the Keycloak password and mails the new one via the
  // LoginDetails.cshtml template. Sibling of welcomePdf; leaner than
  // the legacy send/activate-and-send-details flow (which rejects any
  // user who isn't a business-owner). Migrating to notifications-api
  // is planned separately.
  welcomeEmail: async (body) => {
    return await apiInstance.post("/admin/users/welcome-email", body);
  },
  deleteUser: async (userId) => {
    return await apiInstance.delete(`/admin/users/${userId}`);
  },
  getUserProfile: async (userId) => {
    return await apiInstance.get(`/admin/users/${userId}`);
  },
  updateUserProfile: async (body) => {
    return await apiInstance.put(`/admin/users`, body);
  },
  resetPassword: async (body) => {
    return await apiInstance.post(`/admin/users/reset-password`, body);
  },
};

export const AdminService = {
  getDeviceDetails: async (deviceNumber) => {
    return await apiInstance.get(`/admin/devices/${deviceNumber}`);
  },
  setUpDeviceAuthentication: async (body) => {
    return await apiInstance.post(`/admin/devices/authentication`, body);
  },
  registerDevice: async (body) => {
    return await apiInstance.post(`/admin/devices/register`, body);
  },
  getUsersListing: async (queryParams) => {
    return await apiInstance.get("/admin/users/listing", {
      params: {
        ...queryParams,
      },
    });
  },
  createUser: async (body) => {
    return await apiInstance.post(`/admin/users`, body);
  },
  createBusinessUser: async (body) => {
    return await apiInstance.post(`/admin/users/business`, body);
  },
  sendInvitation: async (body) => {
    return await apiInstance.post("/admin/users/send/invitation", body);
  },
  sendLoginDetails: async (body) => {
    return await apiInstance.post("/admin/users/send/activate-and-send-details", body);
  },
  deleteUser: async (userId) => {
    return await apiInstance.delete(`/admin/users/${userId}`);
  },
  getUserProfile: async (userId) => {
    return await apiInstance.get(`/admin/users/${userId}`);
  },
  updateUserProfile: async (body) => {
    return await apiInstance.put(`/admin/users`, body);
  },
  resetPassword: async (body) => {
    return await apiInstance.post(`/admin/users/reset-password`, body);
  },
};

export const UserProductsApiService = {
  getAssignedProducts: async (params) => {
    return await apiInstance.get(`/admin/products/user/assigned-products`, {
      params: {
        ...params,
      },
    });
  },
  createAssignedProduct: async (body) => {
    return await apiInstance.post(`/admin/products/user/assigned-products`, body);
  },
  deleteAssignedProduct: async (body) => {
    return await apiInstance.put(`/admin/products/user/assigned-products`, body);
  },
};

export const DeviceStyleService = {
  getListing: async (queryParams) => {
    return await apiInstance.get(`/admin/devices/styles`, {
      params: {
        ...queryParams,
      },
    });
  },
  updateStatus: async (body) => {
    return await apiInstance.put(`/admin/devices/styles/update-status`, body);
  },
  getClaimedDevices: async (queryParams) => {
    return await apiInstance.get(`/admin/devices/claimed-devices`, {
      params: {
        ...queryParams,
      },
    });
  },
  updateStyleConfig: async (deviceNumber, body) => {
    return await apiInstance.put(`/admin/devices/styles/${deviceNumber}/config`, body);
  },
};

export const FinancialService = {
  getSubscriptions: async (queryParams) => {
    return await apiInstance.get(`/admin/financials/subscriptions`, {
      params: {
        ...queryParams,
      },
    });
  },
  getSubscriptionPlansListing: async (queryParams) => {
    return await apiInstance.get(`/admin/financials/subscription/plans/listing`, {
      params: {
        ...queryParams,
      },
    });
  },
  getTransactions: async (queryParams) => {
    return await apiInstance.get(`/admin/financials/transactions`, {
      params: {
        ...queryParams,
      },
    });
  },
  getSubscriptionPlans: async (queryParams) => {
    return await apiInstance.get(`/admin/financials/subscription/plans`, {
      params: {
        ...queryParams,
      },
    });
  },
  getSubscription: async (subscriptionId) => {
    return await apiInstance.get(`/admin/financials/subscription/${subscriptionId}`);
  },
  addSubscription: async (body) => {
    return await apiInstance.post(`/admin/financials/subscription`, body);
  },
  addTransaction: async (body) => {
    return await apiInstance.post(`/admin/financials/transaction`, body);
  },
  activateSubscription: async (body) => {
    return await apiInstance.put(`/admin/financials/subscriptions/activate`, body);
  },
  cancelSubscription: async (body) => {
    return await apiInstance.put(`/admin/financials/subscriptions/cancel`, body);
  },
  getPrices: async (queryParams) => {
    return await apiInstance.get(`/admin/financials/prices`, {
      params: {
        ...queryParams,
      },
    });
  },
  addPrice: async (body) => {
    return await apiInstance.post(`/admin/financials/prices`, body);
  },
  updatePrice: async (body) => {
    return await apiInstance.put(`/admin/financials/prices`, body);
  },
  activatePrice: async (body) => {
    return await apiInstance.put(`/admin/financials/prices/activate`, body);
  },
  deactivatePrice: async (body) => {
    return await apiInstance.put(`/admin/financials/prices/deactivate`, body);
  },
  getPricesList: async (queryParams) => {
    return await apiInstance.get(`/admin/financials/prices/list`, {
      params: {
        ...queryParams,
      },
    });
  },
  addCustomSubscription: async (body) => {
    return await apiInstance.post(`/admin/financials/custom/subscriptions`, body);
  },
  sendPaymentLink: async (body) => {
    return await apiInstance.post(`/admin/financials/subscription/send-link`, body);
  },
  sendBusinessPaymentLink: async (body) => {
    return await apiInstance.post(`/admin/financials/business/subscription/send-link`, body);
  },
  getUserSubscription: async (subscriptionId) => {
    return await apiInstance.get(`/financials/subscription/${subscriptionId}`);
  },
  getUserSubscriptions: async (queryParams) => {
    return await apiInstance.get(`/financials/subscriptions`, {
      params: {
        ...queryParams,
      },
    });
  },
  copySubscriptionToUser: async (subscriptionId, body) => {
    return await apiInstance.post(`/financials/subscriptions/${subscriptionId}/copy-to-user`, body);
  },
  getUserTransactions: async (queryParams) => {
    return await apiInstance.get(`/financials/transactions`, {
      params: {
        ...queryParams,
      },
    });
  },
  // getSubscriptionPlansListing: async (queryParams) => {
  //   return await apiInstance.get(`/admin/financials/subscription-plans`, {
  //     params: {
  //       ...queryParams,
  //     },
  //   });
  // },
};

// Alias for backward compatibility (Organisation spelling)
export const OrganisationsApiService = OrganizationsApiService;

export default AdminService;
